import React from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { store } from "../../shared/store";
import { PersonalizedAddonsApp } from "./PersonalizedAddonsApp";
import type { PersonalizedAddonsSeason } from "./types";

const getSeason = (value?: string): PersonalizedAddonsSeason =>
  value === "summer" || value === "fall" ? value : "spring";

document
  .querySelectorAll<HTMLElement>("[data-personalized-addons-root]")
  .forEach((rootElement) => {
    if (rootElement.dataset.reactMounted === "true") return;

    rootElement.dataset.reactMounted = "true";
    createRoot(rootElement).render(
      <React.StrictMode>
        <Provider store={store}>
          <PersonalizedAddonsApp
            season={getSeason(rootElement.dataset.season)}
          />
        </Provider>
      </React.StrictMode>,
    );
  });
